<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <div class="d-flex float-right mb-2">
                <div class="input-group border-bottom position-relative" style="width: 190px">
                    <input
                        class="form-control bg-transparent border-none pr-4"
                        :placeholder="$t('common.search')"
                        aria-label="Search"
                        v-model="searchKeyword"
                        style="min-width: 190px"
                    />
                    <i
                        class="fa fa-search position-absolute"
                        style="top: 50%; right: 4px; margin-top: -6px"
                    />
                </div>
                <div class="mx-3 font-20">|</div>
                <div class="d-flex align-items-center text-nowrap">
                    <b-button variant="outline-primary" @click="openCreateModal">
                        <i class="fa fa-plus-circle mr-2"></i>
                        <span class="text-uppercase">Tạo mới</span>
                    </b-button>
                </div>
            </div>
            <b-table
                class="mt-2"
                striped
                hover
                :items="listPhoto"
                :fields="fields"
                show-empty
                :filter="searchKeyword"
                :filter-included-fields="['description']"
            >
                <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
                <template v-slot:cell(layerId)="data">{{ data.item.layer?.name }}</template>
                <template v-slot:cell(images)="data">
                    <span v-if="data.item.images.length == 0"></span>
                    <img
                        v-else-if="isImage(data.item.images[0])"
                        :src="API_CONFIG.BASE_URL + 'download?fileName=' + data.item.images[0]"
                        style="width: 200px"
                    />
                    <video
                        v-else
                        :src="API_CONFIG.BASE_URL + 'download?fileName=' + data.item.images[0]"
                        style="width: 200px"
                        controls
                    ></video>
                </template>
                <template v-slot:cell(actions)="row">
                    <b-button
                        variant="primary"
                        class="mr-1 min-width-none"
                        @click="openEditModal(row.item)"
                        v-b-tooltip.hover
                        :title="$t('common.edit')"
                    >
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button
                        variant="danger"
                        @click="confirmDelete(row.item)"
                        v-b-tooltip.hover
                        class="min-width-none"
                        :title="$t('common.delete')"
                    >
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
                <template v-slot:empty>
                    <div class="text-center">
                        <span>Không có dữ liệu</span>
                    </div>
                </template>
            </b-table>
            <b-modal
                ref="createOrUpdateModal"
                :title="`${form.id ? $t('common.update') : $t('common.create')}`"
                ok-title="Lưu"
                @ok="handleCreateOk"
                :cancel-title="$t('common.cancel')"
                size="xl"
            >
                <b-form-group label="Vĩ độ">
                    <b-form-input
                        v-model="form.lat"
                        v-validate="'required'"
                        placeholder="Vĩ độ"
                        name="lat"
                        type="number"
                        data-vv-as="Vĩ độ"
                    ></b-form-input>
                    <div v-show="errors.has('lat')" class="validation-message text-danger">
                        {{ errors.first('lat') }}
                    </div>
                </b-form-group>
                <b-form-group label="Kinh độ">
                    <b-form-input
                        v-model="form.long"
                        v-validate="'required'"
                        placeholder="Kinh độ"
                        type="number"
                        name="long"
                        data-vv-as="Kinh độ"
                    ></b-form-input>
                    <div v-show="errors.has('long')" class="validation-message text-danger">
                        {{ errors.first('long') }}
                    </div>
                </b-form-group>
                <b-form-group label="Mô tả">
                    <b-form-input
                        v-model="form.description"
                        v-validate="'required'"
                        placeholder="Mô tả"
                        name="description"
                        data-vv-as="Mô tả"
                    ></b-form-input>
                    <div v-show="errors.has('description')" class="validation-message text-danger">
                        {{ errors.first('description') }}
                    </div>
                </b-form-group>
                <b-form-group label="Liên kết tới lớp dữ liệu">
                    <treeselect
                        :searchable="false"
                        :options="listLayerMap"
                        :normalizer="normalizer"
                        v-model="form.layerId"
                        placeholder="Chọn lớp dữ liệu"
                    />
                </b-form-group>
                <b-form-group label="Chọn hình ảnh, video">
                    <b-form-file
                        v-model="listFile"
                        name="file"
                        multiple
                        placeholder="Chọn hình ảnh, video"
                        accept="video/*,image/*"
                        browse-text="Chọn"
                    ></b-form-file>
                    <b-row class="mt-2">
                        <b-col v-for="image in form.images" :key="image" cols="3">
                            <b-button
                                variant="outline-danger"
                                class="float-right"
                                @click="form.images.splice(form.images.indexOf(image), 1)"
                            >
                                <i class="fa fa-trash"></i>
                            </b-button>
                            <b-img
                                v-if="isImage(image)"
                                fluid
                                :src="API_CONFIG.BASE_URL + 'download?fileName=' + image"
                            />
                            <b-embed v-else type="video" controls aspect="4by3">
                                <source :src="API_CONFIG.BASE_URL + 'download?fileName=' + image" />
                            </b-embed>
                        </b-col>
                    </b-row>
                </b-form-group>
            </b-modal>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import API_CONFIG from '@/api-config';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
    components: {
        DatePicker,
        Treeselect
    },
    async mounted() {
        await this.$nextTick();
        this.listPhoto = await this.getList();
        this.listLayerMap = await this.getLayerTree({ type: 'layer' });
    },
    data: function() {
        return {
            API_CONFIG,
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'images',
                    label: 'Hình ảnh, video'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'lat',
                    label: 'Vĩ độ'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'long',
                    label: 'Kinh độ'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'layerId',
                    label: 'Lớp dữ liệu liên kết'
                },
                {
                    thClass: 'fixed-actions-col',
                    key: 'actions',
                    label: this.$i18n.t('common.actions'),
                    thStyle: { width: '150px' }
                }
            ],
            form: {},
            searchKeyword: null,
            listPhoto: [],
            listFile: [],
            listLayerMap: []
        };
    },
    methods: {
        ...mapActions({
            getList: 'photo/getList',
            create: 'photo/create',
            delete: 'photo/delete',
            update: 'photo/update',
            upload: 'file/upload',
            getLayerTree: 'mapLayer/getListTree',
            createAuditByUser: 'user/createAuditByUser'
        }),
        handleCreateOk(modal) {
            modal.preventDefault();
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.submitForm();
                }
            });
        },
        async openEditModal(item) {
            this.form = { ...item };
            this.$refs.createOrUpdateModal.show();
        },
        openCreateModal() {
            this.form = {};
            this.$refs.createOrUpdateModal.show();
        },
        async confirmDelete(item) {
            const result = await this.$bvModal.msgBoxConfirm('Bạn có chắc chắn muốn xoá không?', {
                title: 'Xác nhận',
                okVariant: 'danger',
                okTitle: 'Có',
                cancelTitle: 'Không'
            });
            if (result) {
                await this.delete(item);
                this.listPhoto = await this.getList();
                this.$toaster.success('Xoá thành công');
                this.createAuditByUser({ content: 'Xoá ảnh' });
            }
        },
        async submitForm() {
            for (const file of this.listFile) {
                const data = await this.upload({ formData: { file } });
                this.form.images = this.form.images || [];
                this.form.images.push(data.path);
            }
            if (this.form.id) {
                await this.update({ ...this.form, layerId: this.form.layerId || null });
            } else {
                await this.create(this.form);
            }
            this.$toaster.success('Thành công');
            this.createAuditByUser({ content: 'Cập nhật ảnh' });
            this.listPhoto = await this.getList();
            this.$refs.createOrUpdateModal.hide();
        },
        normalizer(node) {
            return {
                id: node.id,
                label: node.name,
                children: node.children
            };
        },
        isImage(url) {
            return url.match(/\.(jpeg|jpg|gif|png|svg|webp|bmp|ico|tiff|tif|raw|heif|heic)$/);
        }
    }
};
</script>
